export const FETCH_BLOG_POSTS = 'FETCH_BLOG_POSTS';
export const FETCH_BLOG_POSTS_SUCCESS = 'FETCH_BLOG_POSTS_SUCCESS';
export const FETCH_BLOG_POSTS_FAILED = 'FETCH_BLOG_POSTS_FAILED';

export const FETCH_PUBLIC_BLOG_POSTS = 'FETCH_PUBLIC_BLOG_POSTS';
export const FETCH_PUBLIC_BLOG_POSTS_SUCCESS = 'FETCH_PUBLIC_BLOG_POSTS_SUCCESS';
export const FETCH_PUBLIC_BLOG_POSTS_FAILED = 'FETCH_PUBLIC_BLOG_POSTS_FAILED';

export const FETCH_BLOG_POST = 'FETCH_BLOG_POST';
export const FETCH_BLOG_POST_SUCCESS = 'FETCH_BLOG_POST_SUCCESS';
export const FETCH_BLOG_POST_FAILED = 'FETCH_BLOG_POST_FAILED';

export const EDIT_BLOG_POST = 'EDIT_BLOG_POST';
export const EDIT_BLOG_POST_SUCCESS = 'EDIT_BLOG_POST_SUCCESS';
export const EDIT_BLOG_POST_FAILED = 'EDIT_BLOG_POST_FAILED';

export const DELETE_BLOG_POST = 'DELETE_BLOG_POST';
export const DELETE_BLOG_POST_SUCCESS = 'DELETE_BLOG_POST_SUCCESS';
export const DELETE_BLOG_POST_FAILED = 'DELETE_BLOG_POST_FAILED';

export const ADD_BLOG_POST = 'ADD_BLOG_POST';
export const ADD_BLOG_POST_SUCCESS = 'ADD_BLOG_POST_SUCCESS';
export const ADD_BLOG_POST_FAILED = 'ADD_BLOG_POST_FAILED';



// WEBPACK FOOTER //
// ./src/modules/blog/constants.js